import type { CTAContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: CTAContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function CTASection({ content, branding, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';
  const secondary = branding?.secondaryColor || '#b45309';

  return (
    <div
      className={`${compact ? 'mx-4 my-3 py-6 px-4' : 'mx-6 my-4 py-10 px-8'} rounded-2xl text-center relative overflow-hidden`}
      style={{
        background: `linear-gradient(135deg, ${primary}, ${secondary})`,
      }}
    >
      {/* Decorative circles */}
      <div
        className="absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-10"
        style={{ background: '#fff' }}
      />
      <div
        className="absolute -bottom-8 -left-8 w-24 h-24 rounded-full opacity-10"
        style={{ background: '#fff' }}
      />

      <div className="relative">
        <h2
          className={`${compact ? 'text-sm' : 'text-xl'} font-bold text-white mb-2`}
          style={{ fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
        >
          {content.heading}
        </h2>
        {content.subheading && (
          <p className={`${compact ? 'text-[10px]' : 'text-sm'} mb-4`} style={{ color: 'rgba(255,255,255,0.8)' }}>
            {content.subheading}
          </p>
        )}
        <button
          className={`${compact ? 'px-5 py-1.5 text-[10px]' : 'px-7 py-2.5 text-sm'} rounded-full font-semibold bg-white transition-all hover:scale-105`}
          style={{ color: primary, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' }}
        >
          {content.buttonText}
        </button>
      </div>
    </div>
  );
}
